import {PatientInsuranceDataModel} from '../../../models/patient/patient-insurance-data.model';

export class PatientInsuranceListViewDataModel extends PatientInsuranceDataModel {
  Description: string;
  OrganizationID: string;
  isDefault: boolean;
  hideRow: boolean = false;
  FeeScheduleName: string;
  FeeScheduleID: string;
  PayerID : string;
  PayerIDperNEIC : string;
  PayerOragnization : string;
  patient_DocFeeScheduleID: string;
  patient_DocFeeScheduleID_Description: string ;
}
